/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  TournamentLogger,
  TournamentLoggerInterface,
} from "../TournamentLogger";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "add",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "all",
    outputs: [
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "length",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
    ],
    name: "slice",
    outputs: [
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class TournamentLogger__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TournamentLogger> {
    return super.deploy(overrides || {}) as Promise<TournamentLogger>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): TournamentLogger {
    return super.attach(address) as TournamentLogger;
  }
  connect(signer: Signer): TournamentLogger__factory {
    return super.connect(signer) as TournamentLogger__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TournamentLoggerInterface {
    return new utils.Interface(_abi) as TournamentLoggerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TournamentLogger {
    return new Contract(address, _abi, signerOrProvider) as TournamentLogger;
  }
}
